export default __webpack_public_path__ + "static/media/Group 26977.9c020139.svg";